const deviceType = getDeviceType()

export function goApp(key) {
  const data = [...arguments].slice(1)
  switch (deviceType) {
    case 'ios':
      console.log(key, data)
      break
    case 'android':
      goAndroid(key, data)
      break
    case 'unknown':
      console.log(key, data)
  }
}


export function goAndroid(key, data) {
  const keyArr = key.split('.')
  let target = window
  let parent = null
  for (const item of keyArr) {
    parent = target
    target = target?.[item]
  }
  if (typeof target === 'function') {
    target.call(parent, ...data)
  }
}


export function getDeviceType() {
  const userAgent = navigator.userAgent.toLowerCase()
  if (userAgent.indexOf('android') > -1) {
    return 'android'
  } else if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1 || userAgent.indexOf('ipod') > -1) {
    return 'ios'
  } else {
    return 'unknown'
  }
}

// 获取Android版本
export function getAndroidVersion() {
  const userAgent = navigator.userAgent.toLowerCase()
  const match = userAgent.match(/android\s([0-9\.]*)/)
  return match?.[1]
}

// 获取iOS版本
export function getIOSVersion() {
  const userAgent = navigator.userAgent.toLowerCase()
  const match = userAgent.match(/os\s([\d_]+)/)
  if (match) {
    return match[1].replace(/_/g, '.')
  }
  return undefined
}

// 获取设备版本（自动识别Android或iOS）
export function getDeviceVersion() {
  const deviceType = getDeviceType()
  if (deviceType === 'android') {
    return getAndroidVersion()
  } else if (deviceType === 'ios') {
    return getIOSVersion()
  }
  return undefined
}



